import { t } from 'i18next';
import img1 from '../images/svg/work-1.svg';
import img2 from '../images/svg/work-2.svg';
import img3 from '../images/svg/work-3.svg';
import img4 from '../images/svg/work-4.svg';

const dataWork = [
    {
        id: 1,
        img: img1,
        title: 'CHOOSE YOUR PLATFORM',
        text: t('Selecttheplatform'),
    },
    {
        id: 2,
        img: img2,
        title: 'SELECT COIN AMOUNT',
        text: t('Pick the amount of EA FC 25 Coins you need to enhance your Ultimate Team.'),
    },
    {
        id: 3,
        img: img3,
        title: 'COMPLETE THE PAYMENT',
        text: t('Securely confirm your transaction using PayPal, crypto, or other available methods.'),
    },
    {
        id: 4,
        img: img4,
        title: 'RECEIVE YOUR COINS',
        text: t('Enjoy instant and secure delivery of your EA FC 25 Coins directly to your account.'),
    },
];

export default dataWork;
